import type { SaveData } from "./types";
import { FRAGMENTS_PER_RELIC, relicCatalog } from "./RelicService";

export function explorerJournal(save: SaveData) {
  return {
    relics: relicCatalog(save.unlockedRelics),
    fragments: save.relicFragments,
    fragmentsRequired: FRAGMENTS_PER_RELIC,
    totalTreasuresCollected: save.progression.totalTreasuresCollected,
  };
}
